<template>
    <page-shell title="X-Cube Control">
        <div v-if="!loading">
            <h2>Only use with permission from X-Corp</h2>
            <p>
                This tool can be used to restart the host application on your
                x-cube.<br />
                <b>Required:</b> Your cube needs a functional internet
                connection.<br />
                <br />
                Use in case:
            </p>
            <ul>
                <li>The main screen does not respond to touch</li>
                <li>You started the game in the wrong language</li>
            </ul>
            <v-select v-model="selectedItem" class="custom-select" :options="displayItems" :clearable="true"
                label="display"></v-select>

            <!-- <select
                v-model="selectedItem"
                :disabled="loading"
                class="custom-select"
            >
                <option value="">Select X-CUBE from this list</option>
                <option v-for="item in items" :key="item.id" :value="item">
                    {{ item.name }} {{ item.location.name }}
                </option>
            </select> -->
            <div class="button-container width-90" v-if="selectedItem">
                <p>Selected X-CUBE: {{ selectedItem.name }}</p>
                <el-button type="primary" @click="showConfirmation = true">
                    Restart HOST {{ selectedItem.name }}
                </el-button>
                <h1 v-if="restartRequested">
                    Restart Requested for {{ selectedItem.name }}!
                </h1>
            </div>
            <div v-if="showConfirmation" class="custom-dialog">
                <p>
                    WARNING! MAKE SURE NO GAME OR EXPERIENCE IS IN PROGRESS!
                </p>
                <p>
                    Are you sure you want to restart the
                    {{ selectedItem.name }} X-CUBE?
                </p>
                <el-button type="primary" @click="handleConfirmRestart">
                    YES, RESTART SELECTED X-CUBE
                </el-button>
                <el-button type="primary" class="cancel" @click="showConfirmation = false">
                    NO, PLEASE CANCEL!
                </el-button>
            </div>
        </div>
        <spinner :loading="loading" text="Loading list of available X-Cubes..."></spinner>
    </page-shell>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import PageShell from "../shared/PageShell.vue";
import Spinner from "../shared/Spinner.vue";
import { updateXCube } from "../../api/rest";
import { getUserLocationsSimple } from "../../api/graphql/locations";

const items = ref([]);
const selectedItem = ref("");
const loading = ref(false);
const requestRestart = ref(false);
const restartRequested = ref(false);
const showConfirmation = ref(false);

const displayItems = computed(() => {
    return items.value.map((x) => ({
        ...x,
        display: `${x.location?.name || "????????"} - ${x.name} ${x.letter || ""}`,
    }));
});

const fetchItems = async () => {
    loading.value = true;
    const locations = await getUserLocationsSimple();
    items.value = locations.reduce((acc, loc) => {
        const xCubes =  loc.xcubes.map((x) => ({...x, location :loc}));
        return acc.concat(xCubes);
    }, []);
    loading.value = false;
};

const handleConfirmRestart = async () => {
    const confirmed = confirm("WARNING! MAKE SURE NO GAME OR EXPERIENCE IS IN PROGRESS!");
    if (confirmed) {
        console.log(">> Restart requested!");
        const request_restart = true;
        console.log(">>", selectedItem.value.id, request_restart);
        await updateXCube(selectedItem.value.id, {
            request_restart,
        });

        restartRequested.value = true;
        setTimeout(() => {
            restartRequested.value = false;
        }, 15000);
    }

    showConfirmation.value = false;
};

onMounted(async () => {
    await fetchItems();
    selectedItem.value = "";
});

</script>

<style scoped lang="scss">
@use "../../colors" as *;

.custom-select {
    width: 100%;
    max-width: 24rem;
}

.button-container {
    margin-top: 1.5rem;
}

.custom-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(28rem, calc(100vw - 2rem));
    background-color: $color-background;
    border: 1px solid $color-primary;
    border-radius: 4px;
    padding: 1.25rem;
    color: $color-text-regular;
    z-index: 999;
}

.custom-dialog p {
    margin: 0 0 15px;
}

.custom-dialog .cancel {
    background-color: $color-danger;
    border-color: $color-danger;
    color: $color-text-regular;
}
</style>